<div class="d-flex align-items-center justify-content-between px-4">
  <h2 mat-dialog-title
    class="p-0">
    {{titleKey() | translate}}
  </h2>
  <div>
    <button mat-icon-button
      (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content [class.has-iframe]="iframeUrl()">
  @if (iframeUrl()) {
    <iframe [src]="iframeUrl()"
      class="policy-iframe"></iframe>
  } @else {
    <div [innerHTML]="policyHtml()"></div>
  }
</mat-dialog-content>